import type { ObjPathProxy } from "ts-object-path";
import {
	RecentTimelineItemTypeFilterEnum,
	TimelineHorizonEnum,
	type UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

type ResourcePath = ObjPathProxy<MyPlannResourceDictionary, string>;

type TimelineItemTypeFilter =
	| RecentTimelineItemTypeFilterEnum
	| UpcomingTimelineItemTypeFilterEnum;

const HORIZON_RESOURCES: Record<TimelineHorizonEnum, ResourcePath> = {
	[TimelineHorizonEnum.Month]:
		Resources.NotificationCenter.FilterScreen.Horizon.Month,
	[TimelineHorizonEnum.HalfYear]:
		Resources.NotificationCenter.FilterScreen.Horizon.HalfYear,
	[TimelineHorizonEnum.Year]:
		Resources.NotificationCenter.FilterScreen.Horizon.Year,
};

const TYPE_RESOURCES: Record<TimelineItemTypeFilter, ResourcePath> = {
	[RecentTimelineItemTypeFilterEnum.All]:
		Resources.NotificationCenter.FilterScreen.Type.All,
	[RecentTimelineItemTypeFilterEnum.Activities]:
		Resources.NotificationCenter.FilterScreen.Type.Activities,
	[RecentTimelineItemTypeFilterEnum.Events]:
		Resources.NotificationCenter.FilterScreen.Type.Events,
	[RecentTimelineItemTypeFilterEnum.Notifications]:
		Resources.NotificationCenter.FilterScreen.Type.Notifications,
};

export const DOCUMENTS_TYPE_RESOURCE: ResourcePath =
	Resources.NotificationCenter.FilterScreen.Type.Documents;

export const horizonResource = (horizon: TimelineHorizonEnum): ResourcePath =>
	HORIZON_RESOURCES[horizon];

export const typeResource = (type: TimelineItemTypeFilter): ResourcePath =>
	TYPE_RESOURCES[type];
